export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-projection-screen-2c2f830b4e6e994b1c92f7116bcc35b7.svg";